module.exports = __webpack_public_path__ + "static/media/tip3.b88c23b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Confirmation/img/tips/tip3.jpg
// module id = 974
// module chunks = 0